import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

const html = document.documentElement

const duration = 0.6 // in seconds
const tl = gsap.timeline({
	defaults: {
		ease: "power2.inOut"
	}
});



// This was meant to be a cool transition into the donate flow but
// instead it's ugly coz I suck at it... -LG

export default {
	name: 'slideLeftRight',
	sync: true,
	from: {
		namespace: [
			'project',
			'donate',
			'donate-project',
		]
	},
	to: {
		namespace: [
			'donate',
			'donate-project',
			'donate-checkout',
		]
	},
	leave(data) {
		return tl
			.to(window, {
				scrollTo: 0,
				duration: duration
			})
			.to(data.current.container, {
				x: "-100%",
				duration: duration
			});
	},
	after(data) {
		html.classList.remove('is-loading')
		return tl
			.from(data.next.container, {
				x: "100%",
				duration: duration
			})
	},
}
